import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["flyoutable"];

  toggle(event) {
    const { target } = event.params;

    this.flyoutableTargets.forEach((flyoutable) => {
      if (flyoutable.dataset.identifier !== target) {
        flyoutable.classList.add("hidden");
      } else {
        flyoutable.classList.toggle("hidden");
      }
    });
  }
}
